<div class="rs-padding-top2-m rs-maxh">
  <div class="rs-padding-bottom2 rs-padding-top2-s rs-padding-top4-m rs-maxh">
    <div
      class="{{ cssClasses }}"
      [ngClass]="{ 'rs-panel-clickable rs-clickable': clickable }"
      (click)="((available && !pending) || (active && pending)) && swapPartner()"
      [attr.data-tms-event]="clickable ? 'button-click' : undefined"
      [attr.data-tms-button-zone]="clickable ? 'e-press' : undefined"
      [attr.data-tms-button-name]="clickable ? 'e-press' : undefined"
      [attr.data-tms-action-name]="clickable ? 'addactivate' : undefined"
    >
      <div class="panel rs-bg-grey2 rs-maxh rs-no-margin text-center rs-flex rs-flex-dir-col">
        <div
          class="rs-bgtl-7 rs-bg-red rs-margin2-neg rs-no-margin-bottom rs-no-padding rs-h-s7 rs-h-m30 rs-pos-rel"
        >
          <img
            src="{{ option.image.small }}"
            alt="{{ option.name }} {{ 'epress.box.image.alt.mobile.accessibility' | translate }}"
            class="hide-for-small-only rs-pos-mc rs-h-s20 rs-h-m40"
            data-src="{{ option.image.small }}"
          />
          <img
            src="{{ option.optionImage }}"
            alt="{{ option.name }} {{ 'epress.box.image.alt.app.accessibility' | translate }}"
            class="show-for-small-only rs-pos-mc rs-h-s9"
            data-src="{{ option.optionImage }}"
          />
        </div>
        <div class="rs-padding-top4-m">
          <div class="rs-padding-top2">
            <div class="hide-for-small-only">
              <img
                src="{{ option.optionImage }}"
                alt="{{ option.name }} {{ 'epress.box.image.alt.app.accessibility' | translate }}"
                class="rs-h-s5"
                data-src="{{ option.optionImage }}"
              />
            </div>
            <p class="rs-font-pxB rs-txt-s8 rs-padding-bottom1">
              {{ option.name }}
            </p>
            <ng-container [ngSwitch]="option.optionCodeForDescription">
              <ng-container *ngSwitchCase="'PXCOX'">
                <p class="rs-txt-s2">
                  {{ 'epress.box.hln.subtitle' | translate }}
                </p>
                <p class="rs-txt-s2">
                  {{ 'epress.box.hln.description' | translate }}
                </p>
              </ng-container>
              <ng-container *ngSwitchCase="'CGBXQ'">
                <p class="rs-txt-s2">
                  {{ 'epress.box.le-soir.subtitle' | translate }}
                </p>
                <p class="rs-txt-s2">
                  {{ 'epress.box.le-soir.description' | translate }}
                </p>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div class="rs-flex-grow rs-flex rs-flex-bottom">
          <div class="rs-maxw">
            <div *ngIf="!pending && available" class="jsrs-not-pending">
              <button
                class="rs-btn"
                aria-haspopup="true"
                [ngClass]="{ 'rs-btn-disabled': isAiaPending }"
              >
                {{ 'epress.box.activate' | translate }}
              </button>
            </div>
            <div *ngIf="pending && available" class="jsrs-pending">
              <p>
                <i class="icon-Waiting icon-lh icon-2x rs-txt-warning" aria-hidden="true"></i>
                <span class="rs-txt-warning rs-padding-left1">{{
                  'epress.box.pending' | translate
                }}</span>
              </p>
            </div>
            <div *ngIf="active" class="jsrs-not-pending">
              <p>
                <i class="icon-Validation-box icon-lh icon-2x rs-txt-success" aria-hidden="true"></i
                ><span class="rs-txt-success rs-padding-left1">{{
                  'epress.box.activated' | translate
                }}</span>
              </p>
            </div>
            <div class="hide-for-small-only rs-mh-s6">
              <div class="jsrs-downloadapp" *ngIf="active">
                <button
                  class="rs-btn"
                  role="link"
                  (click)="goToEpressSite()"
                  data-tms-event="button-click"
                  data-tms-button-zone="e-press"
                  data-tms-button-name="start reading"
                >
                  {{ option.configureLink.label[languageService.getSelectedLanguage()] }}
                </button>
              </div>
            </div>
            <div class="show-for-small-only rs-mh-s4">
              <div class="jsrs-downloadapp" *ngIf="active">
                <button
                  class="rs-btn"
                  (click)="openUrlOrApp()"
                  data-tms-event="button-click"
                  data-tms-button-zone="e-press"
                  data-tms-button-name="start reading"
                >
                  {{ option.configureLink.label[languageService.getSelectedLanguage()] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
